import { ReactElement, useCallback } from 'react';

import { createFetchContext } from '../../../../components/contexts/FetchContextFactory';
import { getAdmissionProcessAction } from './managementActions';

export interface AdmissionProcessManagementLoaderProps<T> {
  children: (props: { data: T; refresh: () => Promise<void> }) => ReactElement;
}

const { FetchProvider, FetchConsumer, useFetch } = createFetchContext<
  { id: number },
  any
>();

export const AdmissionProcessManagementLoaderConsumer = FetchConsumer;
export const useAdmissionProcessManagementLoader = useFetch;

export function AdmissionProcessManagementLoaderProvider({
  children,
  defaultQuery,
  fetchImmediately,
}: {
  children: React.ReactNode;
  defaultQuery: { id: number };
  fetchImmediately?: boolean;
}) {
  const request = useCallback((query: { id: number }) => {
    return getAdmissionProcessAction(query);
  }, []);

  return (
    <FetchProvider
      request={request}
      defaultQuery={defaultQuery}
      fetchImmediately={fetchImmediately}
    >
      {children}
    </FetchProvider>
  );
}
